export const encodeJobId = (uid: string): string => {
    if (typeof Buffer === 'undefined') {
        return btoa(uid);
    }
    return Buffer.from(uid).toString('base64');
};

export const decodeJobId = (token: string): string => {
    if (typeof Buffer === 'undefined') {
        return atob(token);
    }
    return Buffer.from(token, 'base64').toString();
};
